import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { formatCurrency } from '@C/TableGrid';

import services from './data';

const SubscriptionPlans = ({ handlePackageChange, value, disabled }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    services
      .getSubscriptionPlans()
      .then((response) => {
        const tmp = response.data.data;
        const categoryOptions = tmp.map((plan) => ({
          value: plan.uuid,
          label: `${plan.name} ${plan.package.plan_name} ${plan.validity} days ${formatCurrency(+plan.price)}`,
        }));
        setOptions(categoryOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleChangeInternal = (selectedOption) => {
    handlePackageChange(selectedOption);
  };

  return (
    <Select
      onChange={handleChangeInternal}
      options={options}
      className="select-box-container"
      classNamePrefix="raw-select"
      name="Plan"
      placeholder="Select subscription plan"
      value={options.filter(({ value: v }) => v === value)}
      isDisabled={disabled || false}
      menuPortalTarget={document.body}
    />
  );
};

export { SubscriptionPlans };
